webpackJsonp([7],{

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(192);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  OAuthCheck: function OAuthCheck(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'user/check', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getProfile: function getProfile(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'user/profile', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  registerUser: function registerUser(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'user/register', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  updateProfile: function updateProfile(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'user/update', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getWorkshop: function getWorkshop(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'workshop', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  getMyWorkShop: function getMyWorkShop(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'user/workshop', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  addMyWorkShop: function addMyWorkShop(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'workshop/register', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  addAssessment: function addAssessment(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'workshop/assessment', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  dashboard: function dashboard(URL, date, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'dashboard/' + date, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  schoolData: function schoolData(URL, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'school', header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vuex_index__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_v_mask__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_mixin_js__ = __webpack_require__(200);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_v_mask__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__vuex_index__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42045d84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(166);
function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var normalizeComponent = __webpack_require__(7)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42045d84_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 161:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5640db12_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__(165);
function injectStyle (ssrContext) {
  __webpack_require__(164)
}
var normalizeComponent = __webpack_require__(7)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5640db12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5640db12_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 164:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 165:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading d-flex w-100 justify-content-center align-items-center"},[_c('div',{staticClass:"spinner-grow text-orange",staticStyle:{"width":"60px","height":"60px"},attrs:{"role":"status"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 166:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid m-0 p-0"},[_c('router-view'),_vm._v(" "),(_vm.$store.state.isLoading)?_c('LoadingView'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 167:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(168);


var Login = function Login() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 205));
};
var Regis = function Regis() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 206));
};
var Dashboard = function Dashboard() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 207));
};
var Workshop = function Workshop() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 208));
};
var Activity = function Activity() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 209));
};
var Profile = function Profile() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 210));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var titlename = 'RMUTL OPEN HOUSE เปิดบ้านราชมงคลล้านนา';

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Login',
    component: Login,
    meta: { title: '' }
  }, {
    path: '/regis/:id',
    name: 'Regis',
    component: Regis,
    meta: { title: 'Register' }
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { title: 'Dashboard' }
  }, {
    path: '/workshop',
    name: 'Workshop',
    component: Workshop,
    meta: { title: 'Workshop' }
  }, {
    path: '/activity',
    name: 'Activity',
    component: Activity,
    meta: { title: 'Activity' }
  }, {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { title: 'Profile' }
  }]
});

router.afterEach(function (to, from) {
  document.title = to.meta.title ? to.meta.title + ' | ' + titlename : titlename;
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 19,
	"./af.js": 19,
	"./ar": 20,
	"./ar-dz": 21,
	"./ar-dz.js": 21,
	"./ar-kw": 22,
	"./ar-kw.js": 22,
	"./ar-ly": 23,
	"./ar-ly.js": 23,
	"./ar-ma": 24,
	"./ar-ma.js": 24,
	"./ar-sa": 25,
	"./ar-sa.js": 25,
	"./ar-tn": 26,
	"./ar-tn.js": 26,
	"./ar.js": 20,
	"./az": 27,
	"./az.js": 27,
	"./be": 28,
	"./be.js": 28,
	"./bg": 29,
	"./bg.js": 29,
	"./bm": 30,
	"./bm.js": 30,
	"./bn": 31,
	"./bn-bd": 32,
	"./bn-bd.js": 32,
	"./bn.js": 31,
	"./bo": 33,
	"./bo.js": 33,
	"./br": 34,
	"./br.js": 34,
	"./bs": 35,
	"./bs.js": 35,
	"./ca": 36,
	"./ca.js": 36,
	"./cs": 37,
	"./cs.js": 37,
	"./cv": 38,
	"./cv.js": 38,
	"./cy": 39,
	"./cy.js": 39,
	"./da": 40,
	"./da.js": 40,
	"./de": 41,
	"./de-at": 42,
	"./de-at.js": 42,
	"./de-ch": 43,
	"./de-ch.js": 43,
	"./de.js": 41,
	"./dv": 44,
	"./dv.js": 44,
	"./el": 45,
	"./el.js": 45,
	"./en-au": 46,
	"./en-au.js": 46,
	"./en-ca": 47,
	"./en-ca.js": 47,
	"./en-gb": 48,
	"./en-gb.js": 48,
	"./en-ie": 49,
	"./en-ie.js": 49,
	"./en-il": 50,
	"./en-il.js": 50,
	"./en-in": 51,
	"./en-in.js": 51,
	"./en-nz": 52,
	"./en-nz.js": 52,
	"./en-sg": 53,
	"./en-sg.js": 53,
	"./eo": 54,
	"./eo.js": 54,
	"./es": 55,
	"./es-do": 56,
	"./es-do.js": 56,
	"./es-mx": 57,
	"./es-mx.js": 57,
	"./es-us": 58,
	"./es-us.js": 58,
	"./es.js": 55,
	"./et": 59,
	"./et.js": 59,
	"./eu": 60,
	"./eu.js": 60,
	"./fa": 61,
	"./fa.js": 61,
	"./fi": 62,
	"./fi.js": 62,
	"./fil": 63,
	"./fil.js": 63,
	"./fo": 64,
	"./fo.js": 64,
	"./fr": 65,
	"./fr-ca": 66,
	"./fr-ca.js": 66,
	"./fr-ch": 67,
	"./fr-ch.js": 67,
	"./fr.js": 65,
	"./fy": 68,
	"./fy.js": 68,
	"./ga": 69,
	"./ga.js": 69,
	"./gd": 70,
	"./gd.js": 70,
	"./gl": 71,
	"./gl.js": 71,
	"./gom-deva": 72,
	"./gom-deva.js": 72,
	"./gom-latn": 73,
	"./gom-latn.js": 73,
	"./gu": 74,
	"./gu.js": 74,
	"./he": 75,
	"./he.js": 75,
	"./hi": 76,
	"./hi.js": 76,
	"./hr": 77,
	"./hr.js": 77,
	"./hu": 78,
	"./hu.js": 78,
	"./hy-am": 79,
	"./hy-am.js": 79,
	"./id": 80,
	"./id.js": 80,
	"./is": 81,
	"./is.js": 81,
	"./it": 82,
	"./it-ch": 83,
	"./it-ch.js": 83,
	"./it.js": 82,
	"./ja": 84,
	"./ja.js": 84,
	"./jv": 85,
	"./jv.js": 85,
	"./ka": 86,
	"./ka.js": 86,
	"./kk": 87,
	"./kk.js": 87,
	"./km": 88,
	"./km.js": 88,
	"./kn": 89,
	"./kn.js": 89,
	"./ko": 90,
	"./ko.js": 90,
	"./ku": 91,
	"./ku.js": 91,
	"./ky": 92,
	"./ky.js": 92,
	"./lb": 93,
	"./lb.js": 93,
	"./lo": 94,
	"./lo.js": 94,
	"./lt": 95,
	"./lt.js": 95,
	"./lv": 96,
	"./lv.js": 96,
	"./me": 97,
	"./me.js": 97,
	"./mi": 98,
	"./mi.js": 98,
	"./mk": 99,
	"./mk.js": 99,
	"./ml": 100,
	"./ml.js": 100,
	"./mn": 101,
	"./mn.js": 101,
	"./mr": 102,
	"./mr.js": 102,
	"./ms": 103,
	"./ms-my": 104,
	"./ms-my.js": 104,
	"./ms.js": 103,
	"./mt": 105,
	"./mt.js": 105,
	"./my": 106,
	"./my.js": 106,
	"./nb": 107,
	"./nb.js": 107,
	"./ne": 108,
	"./ne.js": 108,
	"./nl": 109,
	"./nl-be": 110,
	"./nl-be.js": 110,
	"./nl.js": 109,
	"./nn": 111,
	"./nn.js": 111,
	"./oc-lnc": 112,
	"./oc-lnc.js": 112,
	"./pa-in": 113,
	"./pa-in.js": 113,
	"./pl": 114,
	"./pl.js": 114,
	"./pt": 115,
	"./pt-br": 116,
	"./pt-br.js": 116,
	"./pt.js": 115,
	"./ro": 117,
	"./ro.js": 117,
	"./ru": 118,
	"./ru.js": 118,
	"./sd": 119,
	"./sd.js": 119,
	"./se": 120,
	"./se.js": 120,
	"./si": 121,
	"./si.js": 121,
	"./sk": 122,
	"./sk.js": 122,
	"./sl": 123,
	"./sl.js": 123,
	"./sq": 124,
	"./sq.js": 124,
	"./sr": 125,
	"./sr-cyrl": 126,
	"./sr-cyrl.js": 126,
	"./sr.js": 125,
	"./ss": 127,
	"./ss.js": 127,
	"./sv": 128,
	"./sv.js": 128,
	"./sw": 129,
	"./sw.js": 129,
	"./ta": 130,
	"./ta.js": 130,
	"./te": 131,
	"./te.js": 131,
	"./tet": 132,
	"./tet.js": 132,
	"./tg": 133,
	"./tg.js": 133,
	"./th": 134,
	"./th.js": 134,
	"./tk": 135,
	"./tk.js": 135,
	"./tl-ph": 136,
	"./tl-ph.js": 136,
	"./tlh": 137,
	"./tlh.js": 137,
	"./tr": 138,
	"./tr.js": 138,
	"./tzl": 139,
	"./tzl.js": 139,
	"./tzm": 140,
	"./tzm-latn": 141,
	"./tzm-latn.js": 141,
	"./tzm.js": 140,
	"./ug-cn": 142,
	"./ug-cn.js": 142,
	"./uk": 143,
	"./uk.js": 143,
	"./ur": 144,
	"./ur.js": 144,
	"./uz": 145,
	"./uz-latn": 146,
	"./uz-latn.js": 146,
	"./uz.js": 145,
	"./vi": 147,
	"./vi.js": 147,
	"./x-pseudo": 148,
	"./x-pseudo.js": 148,
	"./yo": 149,
	"./yo.js": 149,
	"./zh-cn": 150,
	"./zh-cn.js": 150,
	"./zh-hk": 151,
	"./zh-hk.js": 151,
	"./zh-mo": 152,
	"./zh-mo.js": 152,
	"./zh-tw": 153,
	"./zh-tw.js": 153
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 196;

/***/ }),

/***/ 197:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(198);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
  // URL: 'http://localhost/open_house/api/',
  URL: 'https://openhouse.rmutl.ac.th/api/',
  isLoading: false,
  screenWidth: 375,
  user: {
    userId: '',
    citizenId: '',
    fullname: '',
    email: '',
    tel: '',
    school: '',
    facId: '',
    facName: '',
    depName: ''
  }
};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_jwt_decode__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_sweetalert2__);




var numeral = __webpack_require__(202);
var moment = __webpack_require__(0);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].mixin({
  data: function data() {
    return {
      header: {
        headers: {
          'Access-Token': localStorage.token,
          'Public-Token': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiT3BlbiBIb3VzZSBSTVVUTCIsInR5cGUiOiJ3ZWJfYXBpIiwiY3JlYXRlIjoiMjAyMi0wOS0wOSAwOTowOTowOSJ9.s8p__DdvjrhZAJAN0Nc8CVV1TnaGHPvXR7NMg-OSl80'
        }
      }
    };
  },

  methods: {
    THAIIDCHECK: function THAIIDCHECK(idCardNumber) {
      if (typeof idCardNumber === 'number') {
        idCardNumber = idCardNumber.toString();
      }

      var regex = /^[0-9]\d*$/;
      if (idCardNumber.length === 13 && idCardNumber.match(regex) && idCardNumber !== null && idCardNumber !== 'undefined') {
        // Check valid id card number
        // return this.idCardCheck(idCardNumber)
        return true;
      } else {
        return false;
      }
    },
    idCardCheck: function idCardCheck(idCardNumber) {
      var sum = 0;
      for (var i = 0; i < idCardNumber.length - 1; i++) {
        sum += parseInt(idCardNumber[i]) * (13 - i);
      }

      var checkDigit = (11 - sum % 11) % 10;

      if (checkDigit === idCardNumber[12]) {
        return true;
      } else {
        return false;
      }
    },
    checkUser: function checkUser() {
      if (localStorage.token === 'undefined' || localStorage.token === undefined || localStorage.token === null || localStorage.token === '') {
        localStorage.clear();
        this.$router.push('/');
      } else {
        this.checkToken(localStorage.token);
      }
    },
    checkToken: function checkToken(token) {
      var jwt = __WEBPACK_IMPORTED_MODULE_1_vue_jwt_decode___default.a.decode(token);
      var TimoOutLogin = this.daysDiff(jwt.create, jwt.expire);
      if (parseInt(TimoOutLogin) <= 0) {
        __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
          icon: 'error',
          title: 'ตรวจสอบการใช้งาน',
          text: 'ท่านเข้าใช้งานเกินเวลาที่กำหนด'
        });
        localStorage.clear();
        this.$router.push('/');
      } else {
        this.getProfile();
      }
    },
    callbackToken: function callbackToken(citizenId) {
      if (localStorage.token === 'undefined' || localStorage.token === undefined || localStorage.token === null || localStorage.token === '') {
        return false;
      } else {
        var jwt = __WEBPACK_IMPORTED_MODULE_1_vue_jwt_decode___default.a.decode(localStorage.token);
        var TimoOutLogin = this.daysDiff(jwt.create, jwt.expire);
        if (parseInt(TimoOutLogin) > 0) {
          return true;
        } else {
          if (citizenId) {
            __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].OAuthCheck(this.$store.state.URL, { citizenId: citizenId }, this.header, function (result) {
              if (result.status === 'SUCCESS') {
                localStorage.token = result.data.accessToken;
                return true;
              } else if (result.status === 'NOT_REGISTER') {
                return false;
              } else {
                return false;
              }
            }, function (_error) {
              return false;
            });
          } else {
            return false;
          }
        }
      }
    },
    OAuth: function OAuth(citizenId) {
      var _this = this;

      this.$store.state.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].OAuthCheck(this.$store.state.URL, { citizenId: citizenId }, this.header, function (result) {
        if (result.status === 'SUCCESS') {
          localStorage.token = result.data.accessToken;
          _this.getProfile();
        } else if (result.status === 'NOT_REGISTER') {
          _this.$router.push('/regis?id=' + citizenId);
        } else {
          __WEBPACK_IMPORTED_MODULE_3_sweetalert2___default.a.fire({
            title: 'ตรวจสอบ',
            text: result.message,
            icon: 'warning',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: 'ตกลง'
          }).then(function (_result) {
            localStorage.clear();
            _this.$router.push('/');
          });
        }
        _this.$store.state.isLoading = false;
      }, function (_error) {
        _this.$store.state.isLoading = false;
        localStorage.clear();
        _this.$router.push('/');
      });
    },
    getProfile: function getProfile() {
      var _this2 = this;

      this.header.headers['Access-Token'] = localStorage.token;
      __WEBPACK_IMPORTED_MODULE_2__services__["a" /* default */].getProfile(this.$store.state.URL, this.header, function (result) {
        if (result.status === 'SUCCESS') {
          _this2.$store.state.user = result.data;
          _this2.$store.state.isLoading = false;
        } else {
          _this2.$store.state.isLoading = false;
          localStorage.clear();
          _this2.$router.push('/');
        }
      }, function (_error) {
        localStorage.clear();
        _this2.$router.push('/');
        _this2.$store.state.isLoading = false;
      });
    },
    daysDiff: function daysDiff(d1, d2) {
      var startDate = moment(d1).format('x');
      // Do your operations
      var endDate = moment(d2).format('x');
      var seconds = (endDate - startDate) / 60000;
      return Math.floor(seconds);
    },
    dateYearThai: function dateYearThai(date) {
      return moment(date).format('YYYY');
    },
    dateMonth: function dateMonth(date) {
      return moment(date).format('YYYY-MM');
    },
    dateTimeFormat: function dateTimeFormat(date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    },
    dateFormat: function dateFormat(date) {
      return moment(date).format('L');
    },
    dateFormatDMY: function dateFormatDMY(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    dateFormatDMY2: function dateFormatDMY2(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    dateFormatMY: function dateFormatMY(date) {
      return moment(date).format('MM/YYYY');
    },
    monthFormat: function monthFormat(str) {
      switch (str) {
        case '01':
          return 'ม.ค';
        case '02':
          return 'ก.พ';
        case '03':
          return 'มี.ค';
        case '04':
          return 'เม.ย';
        case '05':
          return 'พ.ค';
        case '06':
          return 'มิ.ย';
        case '07':
          return 'ก.ค';
        case '08':
          return 'ส.ค';
        case '09':
          return 'ก.ย';
        case '10':
          return 'ต.ค';
        case '11':
          return 'พ.ย';
        default:
          return 'ธ.ค';
      }
    },
    monthYearFormat: function monthYearFormat(str) {
      var date = str.split('-');
      switch (date[1]) {
        case '01':
          return 'มกราคม ' + date[0];
        case '02':
          return 'กุมภาพันธ์ ' + date[0];
        case '03':
          return 'มีนาคม ' + date[0];
        case '04':
          return 'เมษายน ' + date[0];
        case '05':
          return 'พฤษภาคม ' + date[0];
        case '06':
          return 'มิถุนายน ' + date[0];
        case '07':
          return 'กรกฎาคม ' + date[0];
        case '08':
          return 'สิงหาคม ' + date[0];
        case '09':
          return 'กันยายน ' + date[0];
        case '10':
          return 'ตุลาคม ' + date[0];
        case '11':
          return 'พฤศจิกายน ' + date[0];
        default:
          return 'ธันวาคม ' + date[0];
      }
    },
    dateThaiFormat: function dateThaiFormat(str) {
      var date = str.split('-');
      switch (date[1]) {
        case '01':
          return date[2] + ' มกราคม ' + (parseInt(date[0]) + 543);
        case '02':
          return date[2] + ' กุมภาพันธ์ ' + (parseInt(date[0]) + 543);
        case '03':
          return date[2] + ' มีนาคม ' + (parseInt(date[0]) + 543);
        case '04':
          return date[2] + ' เมษายน ' + (parseInt(date[0]) + 543);
        case '05':
          return date[2] + ' พฤษภาคม ' + (parseInt(date[0]) + 543);
        case '06':
          return date[2] + ' มิถุนายน ' + (parseInt(date[0]) + 543);
        case '07':
          return date[2] + ' กรกฎาคม ' + (parseInt(date[0]) + 543);
        case '08':
          return date[2] + ' สิงหาคม ' + (parseInt(date[0]) + 543);
        case '09':
          return date[2] + ' กันยายน ' + (parseInt(date[0]) + 543);
        case '10':
          return date[2] + ' ตุลาคม ' + (parseInt(date[0]) + 543);
        case '11':
          return date[2] + ' พฤศจิกายน ' + (parseInt(date[0]) + 543);
        default:
          return date[2] + ' ธันวาคม ' + (parseInt(date[0]) + 543);
      }
    },
    numberFormat: function numberFormat(str) {
      return numeral(str).format('0,0.00');
    },
    numberFormat2: function numberFormat2(str) {
      return numeral(str).format('00');
    },
    numberFormatold: function numberFormatold(str) {
      return numeral(str).format('0,0');
    }
  }
});

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layouts_Loading__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    LoadingView: __WEBPACK_IMPORTED_MODULE_0__components_layouts_Loading__["a" /* default */]
  },
  created: function created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed: function destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    handleResize: function handleResize() {
      this.$store.state.screenWidth = window.innerWidth;
      // this.$store.state.screenHeight = window.innerHeight
    }
  },
  mounted: function mounted() {
    window.addEventListener('popstate', function () {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').removeClass('theme-light');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').removeClass('modal-open');
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('div').removeClass('modal-backdrop');
    });
  }
});

/***/ })

},[157]);


// WEBPACK FOOTER //
// static/js/app.c742ea516a0a81b4cbef.js